import { tv, type VariantProps } from "../../../util/tv";

export const shareVariant = tv({
  slots: {
    base: ["flex items-center gap-3"],
    item: [],
  },
  variants: {
    wrap: {
      true: {
        base: "flex-wrap justify-center",
      },
      false: {
        base: "flex-nowrap",
      },
    },
  },
});

export type ShareVariantProps = VariantProps<typeof shareVariant>;
